export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/theme/components/scorecard/MetricsLabels/index.js